<div class="dev-switcher" *ngIf="personas.length > 0">
  <label class="dev-label" for="dev-user-switcher-select">DEV</label>
  <select
    id="dev-user-switcher-select"
    [ngModel]="activePersona"
    (ngModelChange)="onSwitch($event)"
    [disabled]="switching"
    class="dev-select"
  >
    <option *ngFor="let p of personas" [value]="p.key">
      {{ p.label }}
    </option>
  </select>
</div>
